export const SCRIPT_DATA_ID = 'react-recaptcha-lib-script';
export const GLOBAL_ONLOAD_FUNCTION = 'reactRecaptchaLibOnload';
